<template>
  <div class="Index" v-if="userInfo.data">
    <div class="popup-box " :class="{zOn:isActive == true}" v-hammer:swipe.down="pagePandown">
      <div :class="{downButton:isActive == true}">
        <img src="../../../static/images/up-btn.png" class="downBtnimg" />
      </div>
      <div class="popup-show">
        <h4>逐日预报</h4>
        <div class="popup-cont">
          <div class="m-table">
            <table class="day-table">
              <tr>
                <td v-for="(item,index) in weekData.date" :key="index">{{item}}</td>
              </tr>
              <tr>
                <td v-for="(item,index) in weekData.time" :key="index">{{item}}</td>
              </tr>
              <tr>
                <td v-for="(item,index) in weekData.weatherD" :key="index">{{item}}</td>
              </tr>
              <tr>
                <td v-for="(item,index) in weekData.weatherD" :key="index"><img :src='"../../../static/images/weather/day/"+ item +".png"' /></td>
              </tr>

            </table>
            <div class="weatherChart" id="myChart1"></div>
            <table class="day-table">
              <tr>
                <td v-for="(item,index) in weekData.weatherN" :key="index"><img :src='"../../../static/images/weather/night/"+ item +".png"' /></td>
              </tr>
              <tr>
                <td v-for="(item,index) in weekData.weatherN" :key="index">{{item}}</td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div class="m-header">
      <h2>{{liveInformationObj.times}}更新</h2>
      <div class="barrage-box">
        <div id="advert" class="animated">
          <div class="bg1">
            <div v-bind:class="classShow?'animtrans':''">
              <ul>
                <li class="icon01 " v-bind:class="classShow?'animtran1':''">
                  <img src="../../../static/images/yl-img.png" alt="">
                  <span>雨量:{{liveInformationObj.xsjs}}</span>
                </li>
              </ul>
            </div>
          </div>
          <div class="bg2">
            <div v-bind:class="classShow?'animtran':''">
              <ul>
                <li class="icon04" v-bind:class="classShow?'animtrans1':''">
                  <img src="../../../static/images/wd-img.png" alt="">
                  <span>气温:{{liveInformationObj.weather}}</span>
                </li>
                <li class="icon03" v-bind:class="classShow?'animtrans2':''">
                  <img src="../../../static/images/sd-img.png" alt="">
                  <span>湿度:{{liveInformationObj.xdsd}}</span>
                </li>
              </ul>
            </div>
          </div>
          <div class="bg3">
            <div v-bind:class="classShow?'animtrans':''">
              <ul>
                <li class="icon02" v-bind:class="classShow?'animtran1':''">
                  <img src="../../../static/images/fx-img.png" alt="">
                  <span>{{liveInformationObj.windPowerObj + liveInformationObj.windDirectionObj}}</span>
                </li>
                <li class="icon05" v-bind:class="classShow?'animtran1':''">
                  <img src="../../../static/images/qy-img.png" alt="">
                  <span>气压:{{liveInformationObj.pressure}}</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="swiper-box">
        <div class="swiper-container" v-if="swiperShow">
          <div class="swiper-wrapper">
            <div class="swiper-slide" v-for="(item,index) in warningObj" :key="index"><span>{{item.pubTime.substring(item.pubTime.lastIndexOf("+")+1)}}发布</span><img v-bind:src="'../../../static/images/warning/'+item.typeName+'' +item.level+'.png'" onerror="this.src='./static/images/err-img.png'" /></div>
          </div>
        </div>
      </div>
    </div>
    <div class="m-cont">
      <div class="scl-box">
        <img v-bind:src="userInfo.data.schoolLogo" />
        <span>{{userInfo.data.schoolName}}</span>
      </div>
      <div class="charts-box">
        <div class="charts-title">
          <h2>近24小时实况</h2>
          <div class="legend-box">
            <ul>
              <li><em></em><span>气温(℃)</span></li>
              <li><em></em><span>降雨量(mm)</span></li>
            </ul>
          </div>
        </div>
        <div class="charts-show" ref="reList">
          <div id="myChart" class="my-chart"></div>
        </div>
      </div>

      <div class="sclbg">
        <img src="../../../static/images/js-title.png" class="js-title" v-if='userInfo.data.schoolName == "东阳市第二实验小学"' />
        <router-link to="/Tzym" v-if='userInfo.data.schoolName == "东阳市第二实验小学"'><img v-bind:src="userInfo.data.schoolPic" class="shc-pic" /></router-link>
        <div v-else><img v-bind:src="userInfo.data.schoolPic" class="shc-pic" /></div>
        <div :class="{upButton:isActive == false}">
          <img src="../../../static/images/up-btn.png" class="upBtnimg" />
        </div>
      </div>
      <div class="notice-box">
        <div class="hjg" v-show="liveInformationObj.hjg">
          <h3>环境光</h3>
          <span>{{liveInformationObj.hjg}}</span>
        </div>
        <div class="zwx"  v-show="liveInformationObj.zwx">
          <h3>紫外线</h3>
          <span>{{liveInformationObj.zwx}}</span>
        </div>
        <div class="snlm" v-show="liveInformationObj.snlm">
          <h3>水泥路面</h3>
          <span>{{liveInformationObj.snlm}}</span>
        </div>
        <div class="cpwd" v-show="liveInformationObj.cpwd">
          <h3>草坪温度</h3>
          <span>{{liveInformationObj.cpwd}}</span>
        </div>
        <div class="pdwd" v-show="liveInformationObj.pdwd">
          <h3>跑道温度</h3>
          <span>{{liveInformationObj.pdwd}}</span>
        </div>
      </div>
    </div>
    <div class="m-bottom" v-hammer:swipe.up="pagePanup">
      <ul>
        <li v-for="(item,index) in bottomList" :key="index" :class="{'onbottom':currentSort==index}">
          <a :href="item.srcUrl">
            <div class="isshow"><span class="new-val">{{item.newVal}}</span></div>
            <div class="ishide"><img v-bind:src="item.img" /><span>{{item.val}}</span></div>
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import echarts from "echarts"
import Swiper from "swiper";
import "swiper/dist/css/swiper.min.css";
export default {

  name: 'Index',
  data() {
    return {
      modalSign1: false, // 弹窗是否打开
      currentSort: 0, // 底部判断选中
      //底部导航
      bottomList: [{
        img: "./static/images/index-img.png",
        val: "首页",
        newVal: "首",
        srcUrl: "#"
      },
      // {
      //   img: "./static/images/qxsy-img.png",
      //   val: "气象术语",
      //   newVal: "术",
      //   srcUrl: "./static/html/sceneTermType.html?miniWXHeadTop=20&wxVersion=7.0.4"
      // },
      {
        img: "./static/images/qxyq-img.png",
        val: "气象仪器",
        newVal: "器",
        srcUrl: "./static/html/equipments.html?miniWXHeadTop=20&wxVersion=7.0.4"
      },
      // {
      //   img: "./static/images/yjxh-img.png",
      //   val: "预警信号",
      //   newVal: "警",
      //   srcUrl: "./static/html/weatherWarn.html?miniWXHeadTop=20&wxVersion=7.0.4"
      // },
      {
        img: "./static/images/zhfy-img.png",
        val: "灾害防御",
        newVal: "防",
        srcUrl: "./static/html/disasterprevention.html?miniWXHeadTop=20&wxVersion=7.0.4"
      },
      ],
      startTime: '', //24小时开始时间
      endTime: '', //24小时结束时间
      sessionId: '', //登录后获取的sessionId
      userInfo: {}, //用户信息
      liveInformationObj: {
        xsjs: '',//雨量
        weather: '',//温度
        xdsd: '',//湿度
        windPowerObj: '',//
        windDirectionObj: '',//
        pressure: '',//气压
        hjg: '',//环境光
        zwx: '',//紫外线
        snlm: '',//水泥路面
        cpwd: '',//草坪温度
        pdwd: '',//跑道温度
      }, //
      warningObj: {},
      selected: 0,
      isActive: false,
      weekData: {}, //七天数据
      classShow: true, //默认显示头部动画样式
      classTimes: '',
      swiperShow: false //判断是否存在预警
    }
  },
  mounted() {
    var query = decodeURI(window.location.search.substring(1));
    var vars = query.split(/\?|\&|\=/g);
    var b = {};
    for (var i = 0; i < vars.length; i = i + 2) {
      b[vars[i]] = vars[i + 1];
    }

    if (vars[0] == "") {
      this.userInfo = {
        "key": "XY330783001"
      }
    } else {
      this.userInfo = b;
    }
    // this.userInfo = {
    // 	"key": "XY330783001"
    // }
    this.getcityObj();
    this.classTimes = setTimeout(this.getClassShow, 3000);
  },

  computed: {},
  methods: {
    getClassShow() {
      this.classShow = false
    },
    pagePanup() {
      this.isActive = true;
    },
    pagePandown() {
      this.isActive = false;
    },
    getcityObj() {
      var that = this;
      requestData('./static/data/user.json', 'get', '', function (res) {
        var b = res[that.userInfo.key];
        that.$set(that.userInfo, "data", b);

        that.getLoginObj();
        // that.getMapWarning(that.userInfo.data.areaName);
        that.getOndayObj(that.userInfo.data.stationNum);
        document.title = that.userInfo.data.schoolName
      })
    },
    weatherChart(xArr, maxD, minD) {
      // 基于准备好的dom，初始化echarts实例
      let myChart1 = this.$echarts.init(document.getElementById('myChart1'))
      // 绘制图表
      myChart1.setOption({
        grid: {
          x: '2%', //相当于距离左边效果:padding-left
          y: '2%', //相当于距离上边效果:padding-top
          bottom: '12%',
          right: '2%',
          top: '18%',
          containLabel: true
        },
        tooltip: {
          trigger: 'item',
          formatter: function (params) {
            var color = params.color; //图例颜色
            var htmlStr = '<div>';
            if (color == "#ff8800") {
              htmlStr += '<span style="position: absolute; left: 18px;">' + params.name + '白天</span><br/>'; //x轴的名称
            } else {
              htmlStr += '<span style="position: absolute; left: 18px;">' + params.name + '夜晚</span><br/>'; //x轴的名称
            }
            htmlStr +=
              '<span style="margin-right:5px;display:inline-block;width:8px;height:8px;border-radius:5px;background-color:' +
              color + ';"></span>';
            htmlStr += '气温:' + params.value + '℃';
            htmlStr += '</div>';

            return htmlStr;
          }
        },
        color: ['#21e4e7'],
        xAxis: {
          "splitLine": {
            "show": false
          },
          "axisLine": { //y轴
            "show": false

          },
          "axisTick": { //y轴刻度线
            "show": false
          },
          axisLabel: {
            "show": false
          },

          data: xArr
        },
        yAxis: [{
          name: '',
          max: maxD,
          min: minD,
          position: 'left',
          type: 'value',
          "axisLine": { //y轴
            "show": false

          },
          "axisTick": { //y轴刻度线
            "show": false
          },
          "splitLine": { //网格线
            "show": false
          },
          axisLabel: {
            "show": false
          }
        }, {
          name: '',
          position: 'right',
          type: 'value',
          "axisTick": { //y轴刻度线
            "show": false
          },
          "splitLine": { //网格线
            "show": false
          },
          axisLine: {
            "show": false
          },
          axisLabel: {
            "show": false
          },
          textStyle: {
            "show": false
          }
        }],
        series: [{
          name: '',
          symbol: 'none',
          smooth: true,
          type: 'line',
          stack: '',
          areaStyle: {
            normal: { //颜色渐变函数 前四个参数分别表示四个位置依次为左、下、右、上
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                offset: 0,
                color: 'rgba(255,136,0,0.5)' // 0% 处的颜色
              }, {
                offset: 1,
                color: 'rgba(255,136,0,0)' // 100% 处的颜色
              }]), //背景渐变色
              lineStyle: { // 系列级个性化折线样式
                width: 1,
                type: 'solid',
                color: "#ff8800" //折线的颜色
              }
            }
          }, //线条样式
          showSymbol: true,
          symbol: 'circle', //设定为实心点
          symbolSize: 8, //设定实心点的大小
          itemStyle: {
            normal: {
              color: "#ff8800",
              label: {
                show: true,
                position: 'top',
                color: "#FFF"
              }
            }
          },
          data: maxD
        },
        {
          name: '',
          type: 'line',
          symbol: 'none',
          smooth: true,
          stack: '',
          areaStyle: {
            normal: { //颜色渐变函数 前四个参数分别表示四个位置依次为左、下、右、上
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                offset: 0,
                color: 'rgba(52,164,166,0.5)' // 0% 处的颜色
              }, {
                offset: 1,
                color: 'rgba(52,164,166,0)' // 100% 处的颜色
              }]), //背景渐变色
              lineStyle: { // 系列级个性化折线样式
                width: 1,
                type: 'solid',
                color: "#34a4a6" //折线的颜色
              }
            }
          }, //线条样式
          showSymbol: true,
          symbol: 'circle', //设定为实心点
          symbolSize: 5, //设定实心点的大小
          itemStyle: {
            normal: {
              color: "#34a4a6",
              label: {
                show: true,
                position: 'bottom',
                color: "#FFF"
              }
            }
          },
          data: minD
        },
        ]
      });
    },
    drawLine(times, rainData, tempData) {
      // 基于准备好的dom，初始化echarts实例
      let myChart = this.$echarts.init(document.getElementById('myChart'))
      // 绘制图表
      myChart.setOption({
        title: {
          text: ''
        },
        grid: {
          x: '2%', //相当于距离左边效果:padding-left
          y: '2%', //相当于距离上边效果:padding-top
          bottom: '15%',
          right: '2%',
          top: '16%',
          containLabel: true
        },
        tooltip: {
          trigger: 'item',
          formatter: function (params) {
            var color = params.color; //图例颜色
            var htmlStr = '<div>';
            htmlStr += '<span style="position: absolute; left: 18px;">' + params.name + '</span><br/>'; //x轴的名称
            htmlStr +=
              '<span style="margin-right:5px;display:inline-block;width:8px;height:8px;border-radius:5px;background-color:' +
              color + ';"></span>';
            if (color == "#ff8800") {
              htmlStr += '气温:' + params.value + '℃';
            } else {
              htmlStr += '降雨:' + params.value + 'mm';
            }
            htmlStr += '</div>';

            return htmlStr;
          }
        },
        color: ['#21e4e7'],
        xAxis: {
          "splitLine": {
            "show": false
          },
          "axisLine": { //y轴
            "show": false

          },
          "axisTick": { //y轴刻度线
            "show": true,
            alignWithLabel: true,
            lineStyle: {
              type: 'solid',
              color: '#cccc99', //左边线的颜色
              width: '2' //坐标线的宽度
            }
          },
          axisLabel: {
            interval: 0, //代表显示所有x轴标签显示
            textStyle: {
              color: '#fff', //坐标值得具体的颜色

            }
          },

          data: times
        },
        yAxis: [{
          name: '',
          splitNumber: 4,
          position: 'left',
          type: 'value',
          "axisLine": { //y轴
            "show": false

          },
          "axisTick": { //y轴刻度线
            "show": false
          },
          "splitLine": { //网格线
            "show": false
          },
          axisLabel: {
            formatter: '{value}mm',
            textStyle: {
              color: '#fff'
            }
          }
        }, {
          name: '',
          splitNumber: 3,
          position: 'right',
          type: 'value',
          "axisTick": { //y轴刻度线
            "show": false
          },
          "splitLine": { //网格线
            "show": false
          },
          axisLine: {
            "show": false
          },
          axisLabel: {
            formatter: '{value}',
            textStyle: {
              color: '#fff'
            }
          },
          textStyle: {
            color: '#00c3f4',
            fontSize: '16'
          }
        }],
        series: [{
          name: '',
          type: 'line',
          symbol: 'none',
          smooth: true,
          stack: '',
          yAxisIndex: 1,
          areaStyle: {
            normal: { //颜色渐变函数 前四个参数分别表示四个位置依次为左、下、右、上
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                offset: 0,
                color: 'rgba(255,136,0,0.5)' // 0% 处的颜色
              }, {
                offset: 1,
                color: 'rgba(255,136,0,0)' // 100% 处的颜色
              }]), //背景渐变色
              lineStyle: { // 系列级个性化折线样式
                width: 1,
                type: 'solid',
                color: "#ff8800" //折线的颜色
              }
            }
          }, //线条样式
          showSymbol: true,
          symbol: 'circle', //设定为实心点
          symbolSize: 8, //设定实心点的大小
          itemStyle: {
            normal: {
              color: "#ff8800",
              label: {
                show: true,
                color: "#FFF",
              }
            }
          },
          data: tempData
        },
        {
          name: '',
          type: 'bar',
          barWidth: '20%',
          itemStyle: {
            normal: {
              color: "#22dde1",
              label: {
                show: true,
                color: "#FFF",
                position: 'top',
              }
            }
          },
          data: rainData
        }
        ]
      });
    },
    // 登录
    getLoginObj() {
      var that = this;
      var newUrl = baseUrl + 'login/login?username=dingw@grassinfo.cn&password=argus@87134963';
      requestData(newUrl, 'get', '', function (res) {
        that.sessionId = res.sessionId;
        localStorage.setItem('key', that.sessionId);
        that.getStationObj(that.sessionId);
      })
    },
    getStationObj(sessionId) {
      var that = this;
      var newUrl = baseUrl + 'basic/queryNodes?sessionId=' + sessionId;
      requestData(newUrl, 'get', '', function (res) {
        if (res.message == "查询成功！") {
          var resData = res.responseBody;
          var resDataAll = resData.datas;
          resDataAll.map((item, index) => {
            if (item.data["no."] == that.userInfo.data.areaNum) {
              that.$set(that.userInfo, "codeId", item.code);
            }

          })
          that.getRealWeather(sessionId);
          that.get24HourLiveData(sessionId);

        }
      })
    },

    // 实况
    getRealWeather(sessionId) {
      var that = this;
      if (that.userInfo.key == "xzxx") {
        requestData(baseUrlAll + 'http://115.238.43.210:8881/json.txt', 'get', '', function (res) {
          that.liveInformationObj = {
			times:res.qwTime,
            xsjs: res.jsl,//雨量
            weather: res.qw,//温度
            xdsd: res.xdsd,//湿度
            windPowerObj: flObj(res.dsfs),//
            windDirectionObj: fxObj(res.dsfx),//
            pressure: res.qy,//气压
            hjg: '',//环境光
            zwx: '',//紫外线
            snlm: '',//水泥路面
            cpwd: '',//草坪温度
            pdwd: '',//跑道温度
          }
        })
      } else {
        var newUrl = baseUrl + 'minute/queryLast?sessionId=' + sessionId + '&code=' + that.userInfo.codeId;
        //newUrl = encodeURIComponent(newUrl)
        requestData(newUrl, 'get', '', function (res) {
          if (res.message == "查询成功！") {
            var resData = res.responseBody.datas;
            resData.map((item, index) => {
              if (item.data.A01 == undefined) {
                that.$set(that.liveInformationObj, "weather", "暂缺");
              } else {
                that.$set(that.liveInformationObj, "weather", item.data.A01 + "℃");
              }

              if (item.data.A02 == undefined) {
                that.$set(that.liveInformationObj, "xdsd", "暂缺");
              } else {
                that.$set(that.liveInformationObj, "xdsd", item.data.A02 + '%');
              }
              if (item.data.A03 == undefined) {
                that.$set(that.liveInformationObj, "pressure", "暂缺");
              } else {
                that.$set(that.liveInformationObj, "pressure", parseInt(item.data.A03) + 'hPa');

              }
              if (item.data.A04 == undefined) {
                that.$set(that.liveInformationObj, "hjg", "5lx");
              } else {
                that.$set(that.liveInformationObj, "hjg", parseInt(item.data.A04) + 'lx');

              }
              if (item.data.A09 == undefined) {
                that.$set(that.liveInformationObj, "zwx", "暂缺");
              } else {
                that.$set(that.liveInformationObj, "zwx", parseInt(item.data.A09));

              }
              if (item.data.X01 == undefined) {
                that.$set(that.liveInformationObj, "cpwd", "暂缺");
              } else {
                that.$set(that.liveInformationObj, "cpwd", item.data.X01 + '℃');

              }
              if (item.data.X02 == undefined) {
                that.$set(that.liveInformationObj, "snlm", "暂缺");
              } else {
                that.$set(that.liveInformationObj, "snlm", item.data.X02 + '℃');

              }
              if (item.data.X03 == undefined) {
                that.$set(that.liveInformationObj, "pdwd", "暂缺");
              } else {
                that.$set(that.liveInformationObj, "pdwd", item.data.X03 + '℃');

              }
              if (item.data.A11 == undefined) {
                var oldTimeData = localStorage.getItem('nowTimes') ? localStorage.getItem('nowTimes') : 0;
                var nowTimeData = new Date().getTime();
                if (nowTimeData - oldTimeData < 1000 * 60 * 15) {
                  that.$set(that.liveInformationObj, "windDirectionObj", localStorage.getItem('windDirectionData'));
                  that.$set(that.liveInformationObj, "windPowerObj", localStorage.getItem('windPowerData'));
                }
              } else {
                that.$set(that.liveInformationObj, "windDirectionObj", flObj(item.data.A11));
                that.$set(that.liveInformationObj, "windPowerObj", fxObj(item.data.A13));
                localStorage.setItem('windDirectionData', that.liveInformationObj.windDirectionObj);
                localStorage.setItem('windPowerData', that.liveInformationObj.windPowerObj);
                localStorage.setItem('nowTimes', new Date().getTime());
              }
              if (item.data.A14 == undefined) {
                var oldTimeData = localStorage.getItem('nowTimes') ? localStorage.getItem('nowTimes') : 0;
                var nowTimeData = new Date().getTime();
                if (nowTimeData - oldTimeData < 1000 * 60 * 15) {
                  that.$set(that.liveInformationObj, "xsjs", localStorage.getItem('liveInformation'));
                }
              } else {
                that.$set(that.liveInformationObj, "xsjs", item.data.A14 + 'mm');
                localStorage.setItem('liveInformation', that.liveInformationObj.xsjs);
                localStorage.setItem('nowTimes', new Date().getTime());
              }

              that.$set(that.liveInformationObj, "zwx", zwxObj((item.data.A09*10)));
              that.$set(that.liveInformationObj, "times", item.time);
            })

          }
        })
      }
    },
    //24小时实况
    get24HourLiveData(sessionId) {
      var that = this;
      var startTime = new Date(new Date().getTime() - 24 * 3600 * 1000).format("yyyy-MM-dd hh");
      var endTime = new Date().format("yyyy-MM-dd hh");
      var newUrl = baseUrl + 'hour/queryByTime?sessionId=' + sessionId + '&start=' + startTime + '&end=' + endTime +
      	'&code=' + that.userInfo.codeId;
      // newUrl = encodeURIComponent(newUrl)
      // requestData(baseUrlAll + newUrl, 'get', '', function(res) {


      // var url = "http://radar.grassinfo.cn:8818/apiTest/nbwechat/appid/dataposition";
      // var data = {
      //   url: baseUrl + 'hour/queryByTime',
      //   data: JSON.stringify({
      //     sessionId: sessionId,
      //     start: startTime,
      //     end: endTime,
      //     code: that.userInfo.codeId
      //   })
      // }
      requestData(newUrl, 'get', '', function (res) {
        var xarr = [],
          rainArr = [],
          tempArr = [];
        if (res.message == "查询成功！") {
          var resData = res.responseBody.datas.slice(0,24);
          resData.map((item, index) => {
            var time = item.time.replace(/-/g, "/");
            var d = "";
            time = new Date(time).format("hh时");
            xarr.push(time);
            d = item.data.A14.sum ? parseFloat(parseFloat(item.data.A14.sum).toFixed(1)) : ""
            rainArr.push(d)
            d = item.data.A01.avg ? parseFloat(parseFloat(item.data.A01.avg).toFixed(1)) : ""
            tempArr.push(d)
          })

        }
        that.drawLine(xarr, rainArr, tempArr);
        let reList = that.$refs.reList
        reList.scrollLeft = 10000
      })
    },
    getWarning(alarm){
        var that = this
        that.warningObj = alarm;
        if (that.warningObj.length == 0) {
        	that.swiperShow = false
        } else {
        	that.swiperShow = true
        }
        that.$nextTick(function () {
          var swiper = new Swiper(".swiper-container", {
            loop: false,
            autoplay: true,
            direction: 'vertical',
            updateOnImagesReady: true,
            noSwiping: true,
            noSwipingSelector: ".zheLine",
            initialSlide: 0,
            pagination: {
              el: ".swiper-pagination"
            },
          });
        })
      },
    getMapWarning(location) {
      var that = this
      requestData('https://geoapi.heweather.net/v2/city/lookup?location=' + location +
      	'&key=ac85b829a6e24245895cccc39bdcad3a', 'get', '',
      	function(res) {
      		that.getMapWarningObj(res.location[0].id)
      	})
    },
    getMapWarningObj(locationId) {
      var that = this
      requestData('https://devapi.heweather.net/v7/warning/now?location=' + locationId +
      	'&key=ac85b829a6e24245895cccc39bdcad3a', 'get', '',
        function (res) {
          that.warningObj = res.warning;
          if (that.warningObj.length == 0) {
            that.swiperShow = false
          } else {
            that.swiperShow = true
          }
          that.$nextTick(function () {
            var swiper = new Swiper(".swiper-container", {
              loop: false,
              autoplay: true,
              direction: 'vertical',
              updateOnImagesReady: true,
              noSwiping: true,
              noSwipingSelector: ".zheLine",
              initialSlide: 0,
              pagination: {
                el: ".swiper-pagination"
              },
            });
          })
        })
    },
    //七天
    getOndayObj(userArea) {
      var that = this;
      var d = {
        date: [],
        time: [],
        weatherD: [],
        weatherN: [],
        windD: [],
        windF: [],
        maxTemp: [],
        minTemp: [],
      };
      var url='https://v1.yiketianqi.com/api?unescape=1&version=v91&appid=71228218&appsecret=8sktelwT&cityid='+userArea;
      requestData(url, 'get', '', function (res) {
        //var weekend = ["日", "一", "二", "三", "四", "五", "六"]
        var data =res.data;
        if (data.length > 0) {
          data.map(function (item, index) {
            if (item.date == new Date().format("yyyy-MM-dd")) {
              d.date.push('今天')
              that.getWarning(item.alarm);
            } else {
              // let date = item.date.substring(0, 4) + "/" + item.date.substring(4, 6) + "/" + item.date.substring(6, 8);
              // date = "星期" + weekend[new Date(date).getDay()];
              d.date.push(item.week);
            }
            let date = item.date.substring(5, item.date.length)
            d.time.push(date);
            if (!item.wea_day || item.wea_day == "") {
              item.wea_day = "无现象"
            }
            d.weatherD.push(item.wea_day);
            if (!item.wea_night || item.wea_night == "") {
              item.wea_night = "无现象"
            }
            d.weatherN.push(item.wea_night);
            d.maxTemp.push(item.tem1);
            d.minTemp.push(item.tem2);
          })
        }
        that.weekData = d;
        that.weatherChart(d.date, d.maxTemp, d.minTemp);
      })
    },
  },

}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
@import "../../../static/css/index.css";
</style>



// WEBPACK FOOTER //
// src/page/index/Index.vue